import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import React from "react";

import {
  MDBCol,
  MDBContainer,
  MDBRow
} from "mdb-react-ui-kit";

import Eventos from "../Eventos/Eventos";
import NoticiasGestion from "../NoticiasGestion/NoticiasGestion";

import { Button, Form, Modal, OverlayTrigger, Popover } from "react-bootstrap";

class Gestionar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      noticias: [],
      isLoading: false,
      showModal: false,
      showPopover: false,
      newTitulo: "",
      newDescripcion: ""
    };
  }

  componentDidMount() {
    this.getNoticias();
  }

  getNoticias = () => {
    this.props.onLoading(true);

    doFetch("HAPK", "getAllNews", null)
      .then((response) => response.json())
      .then((data) => {
        this.setState({ noticias: data.DATA });
      })
      .catch((error) => {
        console.error("Error al obtener datos:", JSON.stringify(error, null, 2));
      })
      .finally(() => {
        this.props.onLoading(false);
      });
  };

  insertNews = async () => {
    let result = false;
    this.props.onLoading(true);

    const { newTitulo, newDescripcion } = this.state;

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        title: newTitulo,
        content: newDescripcion,
      }),
    };

    await doFetch("HAPK", "insertNews", requestOptions)
      .then((response) => response.json())
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          result = true;
          this.getNoticias();
        }
      })
      .catch((error) => {
        console.error("Error al insertar:", JSON.stringify(error, null, 2));
      })
      .finally(() => {
        this.props.onLoading(false);
      });

    return result;
  };

  handleAgregarClick = () => {
    this.setState({ showPopover: false, showModal: true });
  };

  handleCloseModal = () => {
    this.setState({
      showModal: false,
      newTitulo: "",
      newDescripcion: ""
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const success = await this.insertNews();
    if (success) {
      this.handleCloseModal();
    }
  };

  //NO AGREGA LA NOTICIA A LA BASE DE DATOS
  renderPopover = () => (
    <Popover id="popover-basic">
      <Popover.Body>
        <div className="d-flex flex-column gap-2">
          <Button size="sm" variant="success" onClick={this.handleAgregarClick}>
            Agregar
          </Button>
          <Button size="sm" variant="primary" onClick={() => alert("Editar")}>
            Editar
          </Button>
          <Button size="sm" variant="danger" onClick={() => alert("Eliminar")}>
            Eliminar
          </Button>
        </div>
      </Popover.Body>
    </Popover>
  );

  render() {
    const {
      showModal,
      showPopover,
      newTitulo,
      newDescripcion
    } = this.state;

    return (
      <div>
        <h2 className="text-center text-hapkido">GESTIONAR IMÁGENES
          <OverlayTrigger
            trigger="click"
            placement="bottom"
            overlay={this.renderPopover()}
            show={showPopover}
            rootClose
            onToggle={() => this.setState({ showPopover: !showPopover })}
          >
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => this.setState({ showPopover: !showPopover })}
            >
              <i className="fa-solid fa-gear"></i>
            </button>
          </OverlayTrigger>
        </h2>

        <MDBContainer>
          <MDBRow className="mt-3">
            <MDBCol size="9">
              <h2 className="text-center text-hapkido">GESTIONAR NOTICIAS</h2>
              <NoticiasGestion onLoading={this.props.onLoading} />
            </MDBCol>
            <MDBCol size="3">
              <div>
                <h2 className="text-center text-hapkido2">GESTIONAR EVENTOS</h2>
                <Eventos onLoading={this.props.onLoading} />
              </div>
            </MDBCol>
          </MDBRow>
        </MDBContainer>

        <Modal show={showModal} onHide={this.handleCloseModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>Agregar Nueva Noticia</Modal.Title>
          </Modal.Header>
          <Form onSubmit={this.handleSubmit}>
            <Modal.Body>
              <Form.Group className="mb-3">
                <Form.Label>Título</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Título de la noticia"
                  required
                  value={newTitulo}
                  onChange={(e) => this.setState({ newTitulo: e.target.value })}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Descripción</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Descripción..."
                  required
                  value={newDescripcion}
                  onChange={(e) => this.setState({ newDescripcion: e.target.value })}
                />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.handleCloseModal}>
                Cancelar
              </Button>
              <Button variant="primary" type="submit">
                Agregar
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}

export default Gestionar;
